<script setup lang="ts">
import type { CurrentUser } from '@consumer/types/serializers'
import { userMenuFocused } from '../Overlay.vue'
import FlyOut from './FlyOut/FlyOut.vue'
import BuyAGift from './UserMenu/BuyAGift.vue'
import Menu from './UserMenu/Menu.vue'
import MenuButton from './UserMenu/MenuButton.vue'
import ProfilePanel from './UserMenu/ProfilePanel.vue'

const currentUser = inject<Ref<CurrentUser | null>>('currentUser')

function onOpenChange (value: boolean) {
  userMenuFocused.value = value
}
</script>

<template>
  <FlyOut id="user-menu-flyout" @openChange="onOpenChange">
    <template #trigger>
      <MenuButton/>
    </template>

    <template #content>
      <div id="user-menu" class="flex items-stretch">
        <div :class="{ 'p-3': currentUser }">
          <ProfilePanel
            v-if="currentUser"
            layout="desktop"
            class="!rounded-v2md h-full"
            style="width: 315px;"
          />
          <BuyAGift v-else class="!rounded-v2md" style="height: 100%; width: 315px;"/>
        </div>
        <div style="width: 194px;">
          <Menu/>
        </div>
      </div>
    </template>
  </FlyOut>
</template>
